import React, { useState } from 'react'
import { dismissModal } from '../../../../service/modal-service'
import BottomSheet from '../../../commons/BottomSheet'
import { Home, Utensils, Bath, Bed, Wind, AlertCircle, FileText } from 'lucide-react'
import { HELPER_SCOPE } from 'data/part-time-helper-deals'

const SECTION_ICONS = { rooms: Home, bedrooms: Bed, kitchen: Utensils, bathroom: Bath, fan: Wind }

// Section Component for Service Scope
const ScopeSection = ({ icon: Icon, title, items, iconColor = "text-orange-500" }) => (
    <div className="space-y-2">
        <div className="flex items-center gap-2">
            <div className={`w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center ${iconColor}`}>
                <Icon className="w-4 h-4" />
            </div>
            <h4 className="font-semibold text-gray-800 uppercase text-sm">{title}</h4>
        </div>
        <ul className="pl-10 space-y-1.5">
            {items.map((item, i) => (
                <li key={i} className="text-sm text-gray-600 flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-orange-400 rounded-full mt-2 shrink-0"></span>
                    {item}
                </li>
            ))}
        </ul>
    </div>
)

export const HelperServiceScope = () => {
    const [isOpen, setIsOpen] = useState(true)

    // Called after BottomSheet animation completes
    const handleClose = () => {
        dismissModal()
    }

    return (
        <BottomSheet isOpen={isOpen} onClose={handleClose} maxWidth="lg">
            <BottomSheet.Header>
                <div className="flex items-center gap-2">
                    <FileText className="w-5 h-5 text-orange-500" />
                    <BottomSheet.Title>Service Scope</BottomSheet.Title>
                </div>
            </BottomSheet.Header>

            <BottomSheet.Content>
                <div className="space-y-5">
                    {/* Important Notice */}
                    <div className="bg-orange-50 rounded-xl p-3 border border-orange-200">
                        <p className="text-sm text-orange-700">{HELPER_SCOPE.notice}</p>
                    </div>

                    {/* Disclaimers */}
                    <div className="bg-gray-50 rounded-xl p-3 space-y-2">
                        {HELPER_SCOPE.disclaimers.map((text) => (
                            <div key={text} className="flex items-start gap-2">
                                <AlertCircle className="w-4 h-4 text-gray-500 shrink-0 mt-0.5" />
                                <p className="text-xs text-gray-600">{text}</p>
                            </div>
                        ))}
                    </div>

                    {/* Service Sections */}
                    {HELPER_SCOPE.sections.map(({ key, title, items }) => (
                        <ScopeSection key={key} icon={SECTION_ICONS[key]} title={title} items={items} />
                    ))}
                </div>
            </BottomSheet.Content>

            <BottomSheet.Footer>
                <BottomSheet.CloseButton variant="primary" className="w-full">Got it</BottomSheet.CloseButton>
            </BottomSheet.Footer>
        </BottomSheet>
    )
}
